import { Fragment, useState } from "react"

function withLineBreaks(text) {
    // check for <br /> or /n or /r/n
    const lineBreakSymbols = /<br\s*\/?>|\r?\n/i;
    return text.split(lineBreakSymbols).map((line, i) => (
        <Fragment key={i}>
            {line}
            {i < text.split(lineBreakSymbols).length - 1 && <br />}
        </Fragment>
    ));
}

export default function ListEvent({ event, handleSelectEvent }) {

    return (
        
        <div className="list-event" onClick={() => handleSelectEvent(event.id)}>
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                <span className="le-title">{event.summary}</span>
                <div className="le-place"><span>📍</span> <span style={{ width: "75%" }}>{event.location}</span></div>
                <span className="le-time">{event.date}</span>
                <span className="le-description">
                    {
                        event.description.replace(/\?{4,}/g, '').slice(0,51)+(event.description.length > 50 ? "... " : "")
                    }
                </span>
                {/* <button className="le-seemore" onClick={() => handleSelectEvent(event.id)}>See More</button> */}
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="lucide lucide-chevron-right-icon lucide-chevron-right"><path d="m9 18 6-6-6-6"/></svg>
        </div>
    )
}
